import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Gift } from "lucide-react";
import { api } from "../lib/api";

export default function EvoTokenBar({ tokens = 0, goal = 50, onClaimed }) {
  const [playerId, setPlayerId] = useState("");
  const [busy, setBusy] = useState(false);
  const pct = Math.min(100, Math.round((tokens / goal) * 100));
  const ready = tokens >= goal;

  async function claim() {
    if (!/^\d{6,15}$/.test(playerId.trim())) {
      toast.error("Ingresá tu ID de Free Fire (solo números)");
      return;
    }
    setBusy(true);
    try {
      await api.post("/rewards/claim-evo", { player_id: playerId.trim() });
      toast.success(`¡Reclamaste ${goal} tokens evolutivos! Te los enviamos en breve.`);
      setPlayerId("");
      onClaimed?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo reclamar");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div data-testid="evo-token-bar" className="mt-6 rounded-2xl border border-amber-400/30 bg-[#0d0d0d] p-5">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-amber-300" />
          <div>
            <div className="text-xs tracking-[0.3em] text-amber-300">TOKENS EVOLUTIVOS</div>
            <div className="font-display text-2xl tracking-wider">Juntá {goal} y reclamalos</div>
          </div>
        </div>
        <div className="font-display text-3xl tracking-wider" data-testid="evo-token-count">
          {tokens}<span className="text-neutral-500 text-xl"> / {goal}</span>
        </div>
      </div>
      <div className="mt-3 h-4 rounded-full bg-white/5 overflow-hidden border border-white/10">
        <div
          data-testid="evo-token-progress"
          className="h-full rounded-full bg-gradient-to-r from-amber-500 to-[#ff4500]"
          style={{ width: `${pct}%`, transition: "width 600ms ease" }}
        />
      </div>
      {ready ? (
        <div className="mt-4 flex flex-col sm:flex-row gap-2">
          <input
            data-testid="evo-claim-player-id"
            value={playerId}
            onChange={(e) => setPlayerId(e.target.value.replace(/\D/g, "").slice(0, 15))}
            placeholder="Tu ID de Free Fire"
            inputMode="numeric"
            className="input-field flex-1 min-w-0 px-3 py-2.5 rounded-md text-sm"
          />
          <button onClick={claim} disabled={busy} data-testid="evo-claim-btn" className="btn-primary px-5 py-2.5 rounded-md text-sm flex items-center justify-center gap-1.5">
            <Gift className="w-4 h-4" /> {busy ? "Reclamando..." : `Reclamar ${goal} tokens`}
          </button>
        </div>
      ) : (
        <p className="mt-3 text-xs text-neutral-400">Te faltan {goal - tokens} tokens. Los tokens que ganás en las cajas se suman acá.</p>
      )}
    </div>
  );
}
